<template>
  <div>
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Calculadora de pessoas"
            description="Quantidade de pessoas por idade e equipes de saúde"
            url="/gestao-cadastros"
            :enabledModalInformacao="true"
            :enabledIframeModalInformacao="true"
            urlIframeModalInformacao="https://doc.clickup.com/9011510980/d/h/8cj1fp4-1631/599ea88448ce3d9/8cj1fp4-4311"
            pageIdentifier="calculadora-de-pessoas"
            :enableBadgeModalInformacao="
              Number(
                $store.state.permissoesRaw?.calculadora_de_pessoas_ajuda || 0
              ) > 0
            "
            :badgeValueModalInformacao="
              $store.state.permissoesRaw?.calculadora_de_pessoas_ajuda || 0
            "
            keyAjudaModalInformacao="calculadora_de_pessoas_ajuda"
          />
        </div>
      </div>
      <router-view></router-view>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import SectionTitle from '@/components/SectionTitle'

export default {
  components: {
    Menu,
    Footer,
    SectionTitle,
  },
  metaInfo: {
    title: 'Calculadora de Pessoas',
    titleTemplate: null,
  },
  data() {
    return {}
  },
}
</script>

<style></style>
